import React from 'react';
import {createRoot} from 'react-dom/client';
import 'reflect-metadata';
import '@igp/shared/icons.css';
import moment from 'moment-timezone';

import {initStore} from './app/store';
import {App, initContainer} from './app';
import {globalConfig} from './configuration';

moment.tz.setDefault('Etc/UTC');
const config = globalConfig.getConfig();
const container = initContainer(config);
const rootElement = document.getElementById('root');
const {store} = initStore(container, config);
const root = createRoot(rootElement);
root.render(<App container={container} config={config} store={store} />);
